<i class="_icon flex"
   [ngClass]="'icon-' + icon"
   [style.fontSize.px]="iconSize || 20"></i>
@if(textAnimated) {
<p class="_text">
    <span class="p1 p-l-3 p-r-1  no-wrap">
        {{textAnimated}}
    </span>
</p>
}

@if (isBusy) {
<div class="fill flex flex-middle flex-justify-center">
    <loader></loader>
</div>
}